<template>
  <div style="margin-top:80px;">
    <!-- <header>
      <nav class="nav-bar">
        <div class="nav--logo"></div>
        <ul>
          <li data-sal="slide-up"><a href="">博客</a></li>
          <li data-sal="slide-up"><a href="">自我介绍</a></li>
          <li data-sal="slide-up"><a href="">项目</a></li>
          <li data-sal="slide-up"><BaseButton background="transparent" color="white">Test</BaseButton></li>
        </ul>
      </nav>
    </header> -->
    <section>
      <header class="title width-lg" data-sal="slide-right">
        <h1><i class="fal fa-rss" style="color: orange;"></i> <a class="text" href="/blog">&nbsp;个人博客</a></h1>
        <h3><i class="fal fa-pencil-alt" style="color: red;"></i><a class="text" href="/blog/archives"> &nbsp;最新文章</a></h3>
      </header>
      <BaseBlogShow :num="[{ title: 'hello' }]" :posts="posts" class="width-lg" style="margin-top: 30px;" data-sal="zoom-in"> </BaseBlogShow>
    </section>

    <section style="margin-top: 20px;">
      <header class="title width-lg" data-sal="slide-right">
        <h1><i class="far fa-tasks"></i><span class="text">&nbsp;Work</span></h1>
      </header>
      <div class="project-list width-lg" style="margin-top: 100px;">
        <div v-for="(item, index) in projectlist" :key="index" class="project-list--wrapper">
          <BaseInfoCard :item="item" :href="item.href" class="project-list--card" data-sal="zoom-in"></BaseInfoCard>
        </div>
      </div>
    </section>
    <!-- <section class="home">
      <div data-sal="slide-left">
        <h1>Lorem ipsum dolor sit amet.</h1>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Et, alias quas non distinctio aliquam a. Ex expedita omnis molestiae commodi ratione fugit esse, odio veritatis laudantium qui hic in nesciunt.</p>
      </div>
    </section> -->
  </div>
</template>

<script>
import sal from '@/lib/sal'
import api from '@/services/api'
export default {
  mounted() {
    // console.log($('.row'))
    document.querySelectorAll('[data-sal]').forEach(element => {
      element.setAttribute('data-sal-duration', '1200')
      element.setAttribute('data-sal-delay', '300')
      element.setAttribute('data-sal-easing', 'ease-out-bounce')
    })
    sal({
      threshold: 0.3
    })
  },
  created() {
    api.getRecentPosts().then(data => {
      this.$data.posts = data
    })
  },
  data() {
    return {
      posts: [
        {
          id: '0',
          title: 'Loading',
          date: new Date(),
          cate: 'Loading',
          href: '',
          cateHref: '',
          thumb: ''
        }
      ],
      projectlist: [
        {
          cate: 'Github',
          src: 'list/project.jpg',
          title: 'Simple Ajax Promise - Ajaxp',
          p: '使用Promise封装的轻量化ajax库',
          href: 'https://github.com/cyysilver/ajax-promise'
        },
        {
          cate: 'Demo',
          title: 'Real World Vue',
          src: 'list/real-world-vue.jpg',
          p: '使用indexedDB和vue、vue-router、vuex制作的events list',
          href: 'http://www.its-silver.com/real-world-vue'
        },
        {
          cate: 'WIP',
          title: '3d album',
          src: 'list/3d.png',
          p: '使用css transform-style 实现的 3d 相册',
          href: 'http://www.its-silver.com/3d-image-album'
        },
        {
          cate: 'WIP',
          title: 'gallery',
          p: 'modal弹出相册，重构中',
          src: 'list/gallery.jpg',
          href: 'https://codepen.io/CYSILVER/pen/VJopBj'
        },
        {
          cate: '布局',
          title: 'Microsoft页面',
          p: '模仿 Microsoft 主页面以及 Xbox页面',
          src: 'list/ms.png',
          href: 'http://www.its-silver.com/microsoft-home'
        }
        // {
        //   title: 'lorem',
        //   p: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Omnis dicta aspernatur, quas optio corrupti doloribus laborum nihil enim ducimus sequi!',
        //   src: '@/assets/project.png'
        // },
        // {
        //   title: 'lorem',
        //   p: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Omnis dicta aspernatur, quas optio corrupti doloribus laborum nihil enim ducimus sequi!',
        //   src: '@/assets/project.png'
        // }
      ]
    }
  }
}
</script>

<style lang="scss">
@import '@/scss/responsive.scss';
@import '@/scss/mixins.scss';
[debug],
[debug] *:not(a) {
  outline: 1px dashed skyblue;
}

* {
  margin: 0;
  box-sizing: border-box;
}

body {
  background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  font-family: Ubuntu, Roboto, 'Open Sans', 'Microsoft YaHei', sans-serif;
}

.row {
  margin-left: -20px;
  margin-right: -20px;
}

.nav-bar {
  $nav-background: #ff8740;
  $nav-color: #fff;
  @include box-shadow;
  display: flex;
  background: $nav-background;
  * {
    color: $nav-color;
  }
  .nav--logo {
    flex: 1;
  }
  ul {
    height: 65px;
    margin: 0;
    margin-right: 200px;
    padding: 0;
    list-style-type: none;
    display: flex;
    align-items: center;
    li {
      margin: 20px;
    }
  }
}

.home {
  @include box-shadow;
  @include round;
  display: flex;
  align-items: center;
  padding-left: 30px;
  background: linear-gradient(to top right, #fff, #ffa773);
  height: 500px;
  div {
    width: 500px;
  }
}

.title {
  a {
    text-decoration: none;
    color: black;
  }
  h1 {
    padding: 20px 0;
    margin-top: 1em;
    margin-bottom: 1em;
    border-bottom: 2px solid #2c5364;
  }
  h3 {
    display: table;
    padding: 15px;
    padding-right: 20px;
    border-bottom: 2px solid #434343;
  }
  h1,
  h3 {
    .text {
      display: inline-block;
      transition: 0.2s;
      cursor: pointer;
    }
    &:hover .text {
      color: #434343;
      transform: translateX(10px);
    }
  }
}

.project-list {
  display: flex;
  flex-wrap: wrap;

  .project-list--wrapper {
    flex: 0 0 25%;
    .project-list--card {
      height: 400px;
      margin: 20px;
    }
  }
  @media screen and (max-width: $screen-lg) {
    .project-list--wrapper {
      flex: 0 0 33.33%;
      .project-list--card {
        height: 350px;
      }
    }
  }
  @media screen and (max-width: $screen-md) {
    .project-list--wrapper {
      .project-list--card {
        height: 300px;
      }
      flex: 0 0 50%;
    }
  }
  @media screen and (max-width: $screen-sm) {
    .project-list--wrapper {
      flex: 0 0 100%;
    }
  }
}
</style>
